import {Button, withStyles} from '@material-ui/core';

const SquareButton = withStyles({
    root: props => {
        const rootStyles = {
            borderRadius: 3
        };

        if (props.variant !== 'outlined') {
            rootStyles.border = 0;
        }

        if (props.variant === 'contained' && props.color === 'secondary') {
            rootStyles.fontWeight = 'bold';
        }

        return rootStyles;
    },
})(Button);

export default SquareButton;
